export default "__VITE_ASSET__BdnYpUc6__"